export const TagsPreCode = {
    standardImg: `<img src="https://wcm.weborama-tech.ru/fcgi-bin/dispatch.fcgi?a.A=co&a.si=*WCM_ID*&a.cp=*ID*&a.ct=d">`,

    standardScript: `<script type="text/javascript" src="https://cstatic-ru-cv.weborama-tech.ru/public/js/advertiserv2/adperf_conversion.js"></script>
<script type="text/javascript">
var adperftrackobj = {
    fullhost : 'wcm.weborama-tech.ru'
    ,site : *WCM_ID*
    ,conversion_page : *ID*
}
</script>`,

    advancedImg: `<img src="https://wcm.weborama-tech.ru/fcgi-bin/dispatch.fcgi?a.A=co&a.si=*WCM_ID*&a.cp=*ID*&a.ct=d&a.re={REVENUE}&a.cid={CLIENT_IDENTIFIER}&a.iid={INVOICE_IDENTIFIER}&a.inu={ITEMS_NUMBER}&a.isc={IS_CLIENT}&a.opt=N1%3A{value1},N2%3A{value2}">`,

    advancedScript: `<!-- CONVERSION TAG -->
<script type="text/javascript" src="https://cstatic-ru-cv.weborama-tech.ru/public/js/advertiserv2/adperf_conversion.js"></script>
<script type="text/javascript">
var adperftrackobj = {
    client : ""      /* set your client id here */
    ,amount : "0.0"  /* set the total price here */
    ,invoice_id : "" /* set your invoice id here */
    ,quantity : 0    /* set the number of items purchased */
    ,is_client : 0   /* set to 1 if the client is a new client */
    ,partner_name : ""   /* set the partner name - optional parameter */
    ,partner_uid  : ""   /* set the partner user id - optional parameter */
    ,optional_parameters : {
         "N1" : "0" /* to set */
        ,"N2" : "0" /* to set */
        ,"N3" : "0" /* to set */
    /* to set free parameter follow this pattern : */
    /*  ,"customer_type" : "abc" */
    }
    /* don't edit below this point */
    ,fullhost : 'wcm.weborama-tech.ru'
    ,site : *WCM_ID*
    ,conversion_page : *ID*
};
try{adperfTracker.track( adperftrackobj );}catch(err){}
</script>
`,

    setStandardImg: `<body>
...
<button onclick="(new Image()).src='https:\/\/wcm.weborama-tech.ru/fcgi-bin/dispatch.fcgi?a.A=co&a.si=*WCM_ID*&a.cp=*ID*&a.ct=d'">Текст кнопки</button>
...
</body>`,

    setAdvancedImg: `<script>
...
conversionData = {
    revenue: "1000",
    clientID: "1234",
    invoiceID: "1111",
    isClient: "1",
    customParam: "customValue",
    customParam2: "customValue2"
}

document.querySelector("target").addEventListener("event", function() {
    document.createElement("img").src = \`https://wcm.weborama-tech.ru/fcgi-bin/dispatch.fcgi?a.A=co&a.si=*WCM_ID*&a.cp=*ID*&a.ct=d&a.re=\${conversionData.revenue}&a.cid=\${conversionData.clientID}&a.iid=\${conversionData.invoiceID}&a.isc=\${conversionData.isClient}&a.opt=custom_name%3A\${conversionData.customParam},custom_name2%3A\${conversionData.customParam2}\`
});
...
</script>`
};